// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Collapse_wrapper__zLjot","header":"Collapse_header__I2N_I","icon":"Collapse_icon__F5oaf","open":"Collapse_open__Nv0yl","content":"Collapse_content__i8Ouw"};